import { debug as debugGen } from "debug";
import { ActionItem } from "../../types";
import Compose, { ACTION_LEVEL } from "../Compose";

const debug = debugGen("vtTracker:StayCompose");

export enum ACTION_ID {
    PAGE = 133
}

export default class Stay extends Compose {
    compose(): ActionItem {
        const { level, page, item } = this.extraActionItem();

        debug(
            "stay compose level [%d], page [%o], item [%o]",
            level,
            page,
            item
        );

        if ([ACTION_LEVEL.PAGE].includes(level) === false) {
            return null;
        }

        item.action_id = ACTION_ID.PAGE;
        item.action_attr = page.lastVisibleTime % 100000;
        item.action_value = Date.now() - page.lastVisibleTime;

        return item;
    }
}
